export default function VideoSection() {
  return (
    <section className="sa-video-area">
      <div className="sa-container">
        <h2 className="sa-video-title">Watch Campus Life Tour</h2>
        <img
          src="/images/video/5219nm.gif"
          alt="Campus Life Tour"
        />
      </div>
    </section>
  );
}
